export default __webpack_public_path__ + "notFound.231b93621794535ed6eaccd74e873175.svg";